import React, { useEffect, useState } from 'react';
import { connect, ResolveThunks, useSelector } from 'react-redux';
import StyledWrapper from '@insite/client-framework/Common/StyledWrapper';
import WidgetModule from '@insite/client-framework/Types/WidgetModule';
import CustomApplicationState from '@NA/Store/Data/CustomApplicationState/CustomApplicationState';
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";
import ADIColors from "@NA/Utils/ADIColors";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from '@insite/mobius/utilities/getColor';
import { BaseTheme } from '@insite/mobius/globals/baseTheme';
import { StyledButton } from '@insite/mobius/Clickable';
import Hidden from '@insite/mobius/Hidden';
import translate from '@insite/client-framework/Translate';
import OrderDetailPageTypeLink from "@NA/Overrides/Components/OrderDetailPageTypeLink";
import LazyImage from '@insite/mobius/LazyImage';
import WidgetProps from '@insite/client-framework/Types/WidgetProps';
import { HasHistory, withHistory } from '@insite/mobius/utilities/HistoryContext';
import { formattedDateInGrid } from '@NA/Utils/Utility';
import loadOrdersList from '@NA/Handlers/ADILoadOrdersListHandler';
import ChevronRight from '@insite/mobius/Icons/ChevronRight';
import RecentOrdersIcon from '@NA/Icons/RecentOrdersIcon';

const mapStateToProps = (state: CustomApplicationState) => ({
    ordersDataView: state.ADIGlobalData.ordersListStore.ordersList,
    session: state.context.session,
    getOrdersParameter: state.ADIGlobalData.ordersListStore.parameter,
});

const mapDispatchToProps = {
    loadOrdersList,
};

export interface HomeMyRecentOrdersStyles {
    HPPGridContainer?: InjectableCss;
    HPPGridCard?: InjectableCss;
    HPPTitleCardContainer?: InjectableCss;
    HPPTitle?: InjectableCss;
    HPPContentCardContainer?: InjectableCss;
    wrapper?: InjectableCss;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    dataTable?: InjectableCss;
    dataTableHead?: InjectableCss;
    dataTableRow?: InjectableCss;
    Link?: LinkPresentationProps;
    detailsLink?: LinkPresentationProps;
    disabledLink?: TypographyProps;
    DateHeader?: InjectableCss;
    NumberHeader?: InjectableCss;
    POHeader?: InjectableCss;
    ReferenceHeader?: InjectableCss;
    OrderStatus?: InjectableCss;
    totalItemsNumber?: InjectableCss;
    TotalHeader?: InjectableCss;
    TotalHeaderValue?: InjectableCss;
    ItemsHeader?: InjectableCss;
    ItemsTopHeader?: InjectableCss;
    MoreDetailWrap?: InjectableCss;
    MoreDetailProductLineItems?: InjectableCss;
    MoreDetailProductLineItemImg?: InjectableCss;
    mobileGridContainer?: GridContainerProps;
    commanGridItem?: GridItemProps;
    dateAndViewGridItem?: GridItemProps;
    tabitemsCommanGrid?: GridItemProps;
    tabitemsDataContainer?: GridItemProps;
    divider?: InjectableCss;
    dividerMobile?: InjectableCss;
    cardDividerMobile?: InjectableCss;
    verticalDivider?: InjectableCss;
    creationDateText?: TypographyPresentationProps;
    viewDetailsLink?: LinkPresentationProps;
    viewDetailsLinkWrapper?: InjectableCss;
    viewDetailsLinkWrapperTab?: InjectableCss;
    mheading?: TypographyPresentationProps;
    mvalue?: TypographyPresentationProps;
    mvalueTabPO?: TypographyPresentationProps;
    mvaluemobile?: TypographyPresentationProps;
    mvalueHeader?: TypographyPresentationProps;
    tabCreationDateText?: TypographyPresentationProps;
    tabTotal?: TypographyPresentationProps;
    tabHeaderGridContainer?: GridContainerProps;
    tabGridContainer?: GridContainerProps;
    tabOrderStatus?: InjectableCss;
    tabTotalGridItem?: InjectableCss;
    tabOrderStatusGridItem?: InjectableCss;
    tabOrderItemGridItem?: InjectableCss;
    tabPOGridItem?: InjectableCss;
    tabdateAndViewGridItem?: InjectableCss;
    tabNumberGridItem?: InjectableCss;
    orderPOSubheader?: InjectableCss;
    seeAllDetailsWapper?: InjectableCss;
    seeAllDetailsWapperMobile?: InjectableCss;
    moreImagesWrapper?: InjectableCss;
    seeAllDetailsText?: TypographyPresentationProps;
}

export const homeMyRecentOrdersStyles: HomeMyRecentOrdersStyles = {
    HPPGridContainer: {
        css: css`
            margin: 15px 0px;
            display:flex;
            background-color: #f7f7f7;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction:column;
                    `,
                    css`
                        flex-direction:column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    HPPGridCard: {
        css: css`
        width:100%;
        border-radius: 6px;
        background-color: #fff;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    min-height:auto;
                `,
                    css`
                    min-height:auto;
                `,
                    null,
                    null,
                    null,
                ])}
        > ${GridOffset} {
         width:100%;
         margin:0px;
         height: 100%;
        }
    `,
    },
    HPPTitleCardContainer: {
        css: css`
        border-radius: 6px;
        border-bottom-left-radius:0px;
        border-bottom-right-radius:0px;
        padding: 15px 20px;
        background-color: #006892;
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        > svg {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width:28px;
                        height:28px;
                    `,
                    css`
                        width:28px;
                        height:28px;
                    `,
                    null,
                    null,
                    null,
                ])}
        }
    `,
    },
    HPPTitle: {
        css: css`
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        color: #fff;
        margin-left:10px;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size: 16px;
                `,
                    css`
                    font-size: 16px;
                `,
                    null,
                    null,
                    null,
                ])}
    `,
    },
    HPPContentCardContainer: {
        css: css`
        padding: 0px 20px 0px 20px;
        border-radius: 6px;
        border: solid 1px #bbb;
        border-top-left-radius:0px;
        border-top-right-radius:0px;
        border-top:none;
        display: flex;
        flex-direction: column;
        justify-content:flex-start;
        align-items: flex-start;
        width: 100%;
        margin: 0 auto;
         ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    padding: 0px;
                `,
                    css`
                    padding: 0px;
                `,
                    null,
                    null,
                    null,
                ])}
    `,
    },

    wrapper: {
        css: css`
                width: 100%;
                @media (min-width: 1080px) and (max-width: 1366px) {
                    zoom: .88;
                }
            `,
    },
    noResultsContainer: {
        css: css`
                text-align: center;
                width: 100%;
                margin: 0 auto;
                padding: 20px 90px 20px 90px;
                ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 15px 20px 15px 20px;
                   `,
                    css`
                        padding: 15px 20px 15px 20px;
                    `,
                    css`
                         padding: 15px 20px 15px 20px;
                    `,
                    null,
                    null,
                ])}
            `,
    },
    noResultsText: {
        css: css`
                text-align: center;
                font-size: 20px;
                color: #2d2926;
                line-height: normal;
                font-weight: bold;
                display:block;
                ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                             font-size: 16px;
                            `,
                    null,
                    null,
                ])}
            `,
    },
    dataTableHead: {
        css: css`
                padding-top: 4px;
                padding-bottom: 4px;
                background-color: ${ADIColors.white}!important;
                display: flex;               
            `,
    },
    dataTableRow: {
        css: css`
                display: flex;
                padding-top: 10px;
                padding-bottom: 10px;
                background-color: ${ADIColors.white};
                ${TypographyStyle} { 
                    font-size: 14px;
                }
            `,
    },
    DateHeader: {
        css: css`
                flex-basis: 14.3% !important;
                width: 14.3% !important;
                margin: auto;
            `,
    },
    NumberHeader: {
        css: css`
               flex-basis: 14.3% !important;
                width: 14.3% !important;
                margin: auto;
                ${TypographyStyle} { 
                    font-weight: bold;
                }
                span div {
                    display: inline-block;
                    margin: 0px 4px;
                }
                span svg {
                    display: none;
                }
                &.sort-active {
                    background-color: ${ADIColors.white2};
                    &:hover{
                        background-image: none;
                        background-color: ${ADIColors.white2};
                        padding-top: 10px;
                        padding-bottom: 10px;
                    }
                    span {
                        text-decoration: underline;
                    }
                    span svg {
                        display: inline-block;
                    }
                    span .DESC svg {
                        transform: rotate(180deg);
                    }
                }
            `,
    },
    Link: {
        css: css`
                font-size: 14px;
                line-height: 20px;
                color: ${ADIColors.blue5};
                font-weight: bold;
                &:hover {
                    text-decoration: underline;
                }
                ${TypographyStyle} {
                font-weight: 600;
                font-size: 14px;
                 color: ${ADIColors.blue5};
            }
            `,
    },
    detailsLink: {
        css: css`
            ${TypographyStyle} {
                font-weight: 600;
                font-size: 14px;
                 color: #2d2926;
                 text-decoration: underline;
                  &:hover {
        font-size: 14px;
        color: #2d2926;
        font-weight: 600;
         text-decoration: underline;
       }
            }
    `,
    },
    disabledLink: {
        css: css`
                font-size: 14px;
                line-height: 20px;
                color: ${ADIColors.gray10};
                font-weight: bold;
                cursor: none;
                pointer-events: none;
            `,
    },
    POHeader: {
        css: css`
               flex-basis: 14.3% !important;
                width: 14.3% !important;
                margin: auto;
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                span div {
                    display: inline-block;
                    margin: 0px 4px;
                }
                span svg {
                    display: none;
                }
                &.sort-active {
                    background-color: ${ADIColors.white2};
                    &:hover{
                        background-image: none;
                        background-color: ${ADIColors.white2};
                        padding-top: 10px;
                        padding-bottom: 10px;
                    }
                    span {
                        text-decoration: underline;
                    }
                    span svg {
                        display: inline-block;
                    }
                    span .DESC svg {
                        transform: rotate(180deg);
                    }
                }
            `,
    },
    orderPOSubheader: {
        css: css`
               flex-basis: 14.3% !important;
                width: 14.3% !important;
                margin: auto;
                .quoteTooltip {
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 10px 3px;
                    &.activeTab {
                        :hover {
                            overflow: visible !important;
                            position: relative;
                            border-radius: 4px;
                            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
                            border: solid 1px #ececec;
                            background-color: #fff;
                            z-index: 1;
                            padding: 10px 2px;
                            width: fit-content;
                        }
                    }
                }
            `,
    },
    ReferenceHeader: {
        css: css`
                margin: auto;
                flex-basis: 13.3% !important;
                width: 13.3% !important;
                justify-content: flex-start;
                .referenceTooltip {
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 10px 3px;
                    &.activeTab {
                        :hover {
                            overflow: visible !important;
                            position: relative;
                            border-radius: 4px;
                            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
                            border: solid 1px #ececec;
                            background-color: #fff;
                            z-index: 1;
                            padding: 10px 2px;
                            width: fit-content;
                        }
                    }
                }
                span div {
                    display: inline-block;
                    margin: 0px 4px;
                }
                span svg {
                    display: none;
                }
                &.sort-active {
                    padding: 10px 2px;
                    background-color: ${ADIColors.white2};
                    &:hover{
                        background-image: none;
                        background-color: ${ADIColors.white2};
                        padding-top: 10px;
                        padding-bottom: 10px;
                    }
                    span {
                        text-decoration: underline;
                    }
                    span svg {
                        display: inline-block;
                    }
                    span .DESC svg {
                        transform: rotate(180deg);
                    }
                }
            `,
    },
    OrderStatus: {
        css: css`
                flex-basis: 11.3% !important;
                width: 11.3% !important;
                margin: auto;
                span div {
                    display: inline-block;
                    margin: 0px 4px;
                }
                span svg {
                    display: none;
                }
                &.sort-active {
                    background-color: ${ADIColors.white2};
                    &:hover{
                        background-image: none;
                        background-color: ${ADIColors.white2};
                        padding-top: 10px;
                        padding-bottom: 10px;
                    }
                    span {
                        text-decoration: underline;
                    }
                    span svg {
                        display: inline-block;
                    }
                    span .DESC svg {
                        transform: rotate(180deg);
                    }
                }
            `,
    },
    totalItemsNumber: {
        css: css`
                flex-basis: 9.3% !important;
                width: 9.3% !important;
                margin: auto;
                text-align:center;
                span div {
                    display: inline-block;
                    margin: 0px 4px;
                }
                span svg {
                    display: none;
                }
                &.sort-active {
                    background-color: ${ADIColors.white2};
                    &:hover{
                        background-image: none;
                        background-color: ${ADIColors.white2};
                        padding-top: 10px;
                        padding-bottom: 10px;
                    }
                    span {
                        text-decoration: underline;
                    }
                    span svg {
                        display: inline-block;
                    }
                    span .DESC svg {
                        transform: rotate(180deg);
                    }
                }
            `,
    },
    TotalHeader: {
        css: css`
                flex-basis: 13.3% !important;
                width: 13.3% !important;
                padding:10px 25px 5px 10px ;
                text-align: right;
                margin: auto;
    ${TypographyStyle} {
                    max-width: 115px;
                    width: 115px;
                    margin-right: 0px;
                    justify-content: flex-end;
                    padding: 0;
                    font-size: 14px;
                    color: ${getColor("text.main")};
                    font-weight: bold;
                    text-align: right;
                }
            `,
    },
    TotalHeaderValue: {
        css: css`
                flex-basis: 13.3% !important;
                width: 13.3% !important;
                padding:0px 25px 0px 10px;
                text-align: right;
                margin: auto;
    ${TypographyStyle} {
                    max-width: 115px;
                    width: 115px;
                    margin-right: 0px;
                    justify-content: flex-end;
                    padding: 0;
                    font-size: 14px;
                    color: ${getColor("text.main")};
                    font-weight: bold;
                    text-align: right;
                }
            `,
    },
    ItemsHeader: {
        css: css`
                flex-basis: 41.2% !important;
                width: 41.2% !important;
                border-left: solid 2px ${ADIColors.white2};
                padding: 0px 0px;
                padding-left: 19px;
                margin: auto;
            `,
    },
    ItemsTopHeader : {
        css: css`
                flex-basis: 41.2%;
                width: 41.2%;
                padding: 10px 0px;
                padding-left: 19px;
                margin: auto;
            `,
    },
    MoreDetailWrap: {
        css: css`
                display: flex;
                flex-flow: row nowrap;
                flex-grow: 1;
                text-overflow: ellipsis;
                min-width: 0;
                white-space: normal;
                justify-content: flex-start;

                overflow: initial;
                margin: auto;
                align-items: center;
            `,
    },
    MoreDetailProductLineItems: {
        css: css`
                display: flex;
                width: 100%;
            `,
    },
    MoreDetailProductLineItemImg: {
        css: css`
                width: calc(25% - 15px);
                margin-right: 15px;
                float: left;
                max-height: 54px;
                max-width: 54px;
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            max-width:45px;
                        `,
                    css`
                            max-width:45px;
                        `,
                    css`
                            max-width:54px;
                        `,
                    null,
                    null,
                ])}
            `,
    },
    commanGridItem: {
        css: css`
        padding: 0px;
                display: flex;
                justify-content: space-between;
                margin-top: 0;
                margin-bottom: 0;
                padding-top: 0;
                padding-bottom: 8px;
            `,
    },
    tabitemsCommanGrid: {
        css: css`
                margin: 0 20px !important;
                padding: 20px 0 !important;
                display: flex;
                align-items: center;
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [
                        css` `,
                        css` `,
                        css` margin: 0px !important;padding: 0 0 20px !important; `,],); 
                }}
            `,
    },
    tabitemsDataContainer: {
        css: css`
            > ${GridOffset} {
                width:100%;
                margin:0px;
                > ${GridItemStyle} {
                    padding:0px;
                    align-items:center;
                }
    
            }
            `,
    },
    tabGridContainer: {
        css: css`
            margin-top:12px;
            padding:0px;
            width:100%;
            background-color:#fff;
            border-bottom: 1px solid ${ADIColors.gray2};
            ${({ theme }) => { return breakpointMediaQueries(
                theme, [
                    css` `,
                    css` `,
                    css` margin: 0; `,],); 
            }}
            > ${GridOffset} {
                width:100%;
                margin:0px;
                justify-content: space-between;
    
            }
            
        `,
    },
    tabHeaderGridContainer: {
        css: css`
                background-color: ${ADIColors.white};
             border-bottom: 1px solid ${ADIColors.gray2};
            `,
    },
    dateAndViewGridItem: {
        css: css`
                display: flex;
                justify-content: space-between;
                margin-top: 0;
                margin-bottom: 0;
                padding-top: 0px;
                padding-bottom: 0px;
                ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`padding-right: 0px;`,
                    css`padding-right: 0px;`,
                    null,
                    null,
                    null,
                ])} 
            `,
    },
    mobileGridContainer: {
        css: css`
                padding: 20px 20px 0 20px;
                background-color: ${ADIColors.white};
                &.tabletGridContainer {
                    @media only screen and (min-width: 1079px) and (max-width: 1200px) {
                        display: none !important;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                    display: none !important;
                                `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
                }
                @media (max-width: 1079px) {
                    max-width: 100%;
                }
            `,
    },
    divider: {
        css: css`
                width: 100%;
                height: 1px;
                align-self: stretch;
            flex-grow: 0;
                border-bottom: 1px solid ${ADIColors.gray2};
            `,
    },
    dividerMobile: {
        css: css`
                width: 100%;
                height: 1px;
                align-self: stretch;
                flex-grow: 0;
                margin-top:12px;
                margin-bottom:12px;
                border-bottom: 1px solid ${ADIColors.gray2};
            `,
    }, cardDividerMobile: {
        css: css`
                width: 100%;
                height: 2px;
                align-self: stretch;
                flex-grow: 0;
                margin-top:12px;
                margin-bottom:12px;
                border-bottom: 1px solid #bbb;
            `,
    },
    verticalDivider: {
        css: css`
                width: 1px;
                height: 19px;
                align-self: stretch;
            flex-grow: 0;
            margin-left:10px;
            margin-right:10px;
            background-color:${ADIColors.gray2};
            `,
    },
    creationDateText: {
        css: css`
                text-transform: capitalize;
                font-size: 14px;
                line-height: 14px;
                margin-left: 0;
                color: ${ADIColors.darkBlue1};
                font-weight: bold;
            `,
    },
    viewDetailsLink: {

        css: css`
                padding-right: 0;
                font-size: 14px;
                position: relative;
                font-weight: 600;
                color: #2d2926;
                text-decoration: underline;
                padding-top: 2px;
                height: auto !important;
                position: relative;
                line-height: 14px;
               
                ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                            justify-content:flex-end;padding-top: 0px;
                        `,
                    css`
                            
                        `,
                    css`
                        
                        `,
                ]);
            }}
            `,
    }, viewDetailsLinkWrapper: {
        css: css`
         display:flex;
         flex-directon:row;
         cursor: pointer;
        svg {
            height: 16px;
            width: 16px;
            position: relative;
            stroke-width: 3;
            color: ${ADIColors.darkBlack3};
        }
            `,
    }
    , viewDetailsLinkWrapperTab: {
        css: css`
        display:flex;
        flex-directon:row;
        width:100%;
        justify-content:end;
        cursor: pointer;
       svg {
           height: 16px;
           width: 16px;
           position: relative;
           stroke-width: 3;
           color: ${ADIColors.darkBlack3};
       }
           `,
    },
    mheading: {
        css: css`
                font-weight: bold;
                color: ${getColor("text.main")};
                font-size: 14px;
                line-height: 14px;
            `,
    },
    mvalue: {
        css: css`
                font-size: 14px;
                line-height: 14px;
                margin: auto 0;
                 text-overflow: ellipsis;
                ${StyledButton} {
                    color: ${getColor("text.main")};
                    cursor: none;
                    pointer-events: none;
                    > ${TypographyStyle} {
                        color: ${getColor("text.main")};
                    }
                }
            `,
    },
    mvalueTabPO :{
        css: css`
        font-size: 14px;
        line-height: 14px;
        margin: auto 0;
        text-overflow: ellipsis;
        pointer-events: none;
        
        ${StyledButton} {
            color: ${getColor("text.main")};
            cursor: none;
            pointer-events: none;
            > ${TypographyStyle} {
                color: ${getColor("text.main")};
            }
        }
         ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        pointer-events: none;
                        text-decoration:none;
                        &:hover{
                            text-decoration:none;
                            pointer-events: none;
                        }
                        &:active{
                            text-decoration:none;
                            pointer-events: none;
                        }
                        `,
                    css`
                            
                        `,
                    css`
                        
                        `,
                ]);
        }}
    `,
    },
    mvaluemobile: {
        css: css`
                font-size: 14px;
                line-height: 14px;
                margin: auto 0;
                 text-overflow: ellipsis;
                ${StyledButton} {
                    color: #006ae3;
                    cursor: none;
                    pointer-events: none;
                    > ${TypographyStyle} {
                        color: #006ae3;
                    }
                }
            `,
    },
    mvalueHeader: {
        css: css`
                flex-grow: 0;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2d2926;
            `,
    },
    tabCreationDateText: {
        css: css`
                font-size: 14px;
                line-height: 14px;
            `,
    },
    tabTotal: {
        css: css`
                margin-right: 4px;
                justify-content: flex-end;
                padding: 0 16px 0 0;
                font-size: 14px;
                color: ${getColor("text.main")};
                font-weight: bold;
                text-align: right;
            `,
    },
    tabOrderStatus: {
        css: css`
                flex-basis: 14.28%!important;
                width: 14.28% !important;
                padding: 5px 10px 5px 5px;
                font-size: 16px;
                font-weight: bold;
                margin: 0px;
                line-height: normal;
                height: 100%;
                span div {
                    display: inline-block;
                    margin: 0px 4px;
                }
                span svg {
                    display: none;
                }
                &.sort-active {
                    background-color: ${ADIColors.white2};
                    span {
                        text-decoration: underline;
                    }
                    span svg {
                        display: inline-block;
                    }
                    span .DESC svg {
                        transform: rotate(180deg);
                    }
                }
            `,
    },
    tabdateAndViewGridItem: {
        css: css`
                flex-basis: 15.1761517615% !important;
                width: 15.1761517615% !important;
                max-width: 15.1761517615% !important;
                padding:0px;
                padding-left:20px;
                min-height:54px;
                align-items: center;
            `,
    },
    tabNumberGridItem: {
        css: css`
                flex-basis: 14.28% !important;
                width: 14.28% !important;      
                max-width: 13.4146341463% !important;
                padding:0px;
                padding-left:24px;
                min-height:54px;
                align-items: center;
                font-size: 14px;
                font-weight: bold;
            `,

    },
    tabPOGridItem: {
        css: css`
               flex-basis: 14.28% !important;
                width: 14.28% !important;
                max-width: 26.0162601626% !important;
                padding:0px;
                padding-left:24px;
                min-height:54px;
                align-items: center;
            `,

    },
    tabOrderStatusGridItem: {
        css: css`
               flex-basis: 14.28% !important;
                width: 14.28% !important;
                max-width: 27.7777777778% !important;
                padding:0px;
                padding-left:24px;
                min-height:54px;
                align-items: center;
            `,

    },
    tabOrderItemGridItem: {
        css: css`
               flex-basis: 14.28% !important;
                width: 14.28% !important;
                max-width: 27.7777777778% !important;
                padding:0px;
                padding-left:24px;
                min-height:54px;
                align-items: center;
                ${({ theme }) =>
                    breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`padding-left:35px;`,
                ])} 
            `,

    },
    tabTotalGridItem: {
        css: css`
                flex-basis: 14.28% !important;
                width: 14.28% !important;
                max-width: 17.6151761518% !important;
                justify-content: flex-end;
                padding:0px;
                padding-left:5px;
                padding-right:20px;
                min-height:54px;
                align-items: center;
                font-weight: bold;
                ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`padding-right:0px;`,
                ])} 
                > ${TypographyStyle} {
                    padding:0px;
                    margin:0px;
                    text-align:right;
        
                }
    
            `,
    },
    seeAllDetailsText: {
        css: css`
            text-align: right;
            font-size: 14px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: normal;
            color: #006ae3;
            cursor: pointer;
            ${StyledButton} {
                &:hover {
                    ${TypographyStyle}{
                        color: #006ae3;
                        text-decoration: underline;
                    }
                }
            }   
         `,
    },
    seeAllDetailsWapper: {
        css: css`
            width: 100%;
            padding: 10px 0px 15px 10px;
            text-align: right;
            line-height: 1;                
            `,
    }, seeAllDetailsWapperMobile: {
        css: css`
                        width: 100%;
                        padding:10px;
                        padding-top:0px;
                        text-align: center;
                    `,
    }, moreImagesWrapper: {
        css: css`
        width: 54px;
        height: 54px;
        border: 1px solid #ddd;
        border-radius: 4px;
        align-content: center;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        ${TypographyStyle} {
            font-size: 14px;
        }
        `
    }


};
const styles = homeMyRecentOrdersStyles;
type Props = WidgetProps & HasHistory & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ADIHomeMyRecentOrder = ({ ordersDataView, history, session, loadOrdersList, getOrdersParameter }: Props) => {

    const sort = "OrderDate DESC";
    const [isLoading, setLoading] = useState(false);
    const userRoles = useSelector((state: CustomApplicationState) => state.context.session.userRoles);
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;    
    const isOrderDataAccess = userRoles && (userRoles.includes("FullAccess") || userRoles.includes("LimitedAccess") || userRoles.includes("Employee"));
    useEffect(() => {
        setLoading(true);
        if(isAuthenticated && isOrderDataAccess){ 
            loadOrdersList({
                ...getOrdersParameter,
                filter: {
                    refrencenumber: "",
                    ordersearchtype: "All",
                    status: "All",
                    fromDate: "",
                    toDate: "",
                    sort,
                    customerSequence: "-1",
                    currentPage: 1,
                    pageSize: 3,
                    dateType: "",
                    selectedpage: 1,
                    dateRange: "",
                    dateRangeDesc: "",
                    statusDesc: "All",
                    page: 1,
                    poNumber: "",
                    isSearchActive: false,
                },
                onComplete() {
                    setLoading(false)
                },
            });
        }
    }, []);

    const showAttributesForAvailableOrders = (noOfOrderLine: any) => {
        return noOfOrderLine != null && parseInt(noOfOrderLine) > 0;
    };
    const formatDate = (inputDate: any): string => {
        const date = new Date(inputDate);
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const year = date.getFullYear().toString();

        const formattedDate = `${month}/${day}/${year}`;
        return formattedDate;
    };

    const orders = ordersDataView?.orders;
    const rows = orders?.map(order => ({
        id: order.id,
        creationDate: formattedDateInGrid(order.properties.creationDate),
        erpOrderNumber: order.erpOrderNumber,
        webOrderNumber: order.webOrderNumber,
        customerPO: order.customerPO,
        status: order.subStatus,
        orderTotalDisplay: order.orderTotalDisplay,
        noOfOrderLine: order.noOfOrderLine,
        productLineItems: order.productLineItems,
        orderDate: formatDate(order.orderDate),
        suffix: order.suffix,
    }));

    const rowsSlice = rows?.slice(0, 3)

    const customerSuffix = ordersDataView?.properties?.customerSuffix ?? "";

    const handleButtonClick = (orderNumber: string, orderDate: string, erpOrderNumber: string) => {
        const getCurrentOrder = orders?.find((item: any) =>
            orderNumber ? item.webOrderNumber === orderNumber : item.erpOrderNumber === erpOrderNumber,
        );
        sessionStorage.removeItem("selectedOrder");
        sessionStorage.setItem("selectedOrder", JSON.stringify(getCurrentOrder));
        history.push(
            `/MyAccount/Order/Details?orderNumber=${orderNumber}_orders_${customerSuffix}&suffix=${customerSuffix}&orddate=${orderDate}`,
        );
    };

    const redirectToOrder = () => history.push("/MyAccount/Order");
    if (!isAuthenticated) {
        return null;
    }
    
    return (
        <>{!isLoading && isAuthenticated && rowsSlice &&
            <StyledWrapper {...styles.HPPGridContainer}>
                <StyledWrapper {...styles.HPPGridCard}>
                    <StyledWrapper  {...styles.HPPTitleCardContainer}>
                        <RecentOrdersIcon />
                        <Typography {...styles.HPPTitle}>My Recent Orders</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.HPPContentCardContainer}>
                        <StyledWrapper style={{ display: "contents" }}>
                            {rowsSlice && rowsSlice?.length === 0 ?
                                <StyledWrapper {...styles.noResultsContainer}>
                                    <Typography {...styles.noResultsText}>
                                        {translate("There are no orders to display at this time.")}
                                    </Typography>
                                    <Typography {...styles.noResultsText}>
                                        {translate("Once you've placed an order with us, it will appear here, so start shopping our extensive product selection today.")}
                                    </Typography>
                                </StyledWrapper>
                                :
                                <>
                                    <StyledWrapper {...styles.wrapper}>
                                        <Hidden below="lg">
                                            <>
                                                <StyledWrapper>
                                                    <StyledWrapper {...styles.dataTableHead}>
                                                        <StyledWrapper
                                                            {...styles.DateHeader}>
                                                            <Typography {...styles.mvalueHeader}>{translate("Date")}</Typography>
                                                        </StyledWrapper>
                                                        <StyledWrapper
                                                            {...styles.NumberHeader}>
                                                            <Typography {...styles.mvalueHeader}>{translate("Order #")}</Typography>
                                                        </StyledWrapper>
                                                        <StyledWrapper
                                                            {...styles.POHeader}>
                                                            <Typography {...styles.mvalueHeader}>{translate("PO #")}</Typography>
                                                        </StyledWrapper>
                                                        <StyledWrapper
                                                            {...styles.ReferenceHeader}>
                                                            <Typography {...styles.mvalueHeader}>{translate("Ref #")}</Typography>
                                                        </StyledWrapper>
                                                        <StyledWrapper
                                                            {...styles.OrderStatus}>
                                                            <Typography {...styles.mvalueHeader}> {translate("Status")}</Typography>
                                                        </StyledWrapper>

                                                        <StyledWrapper
                                                            {...styles.totalItemsNumber}>
                                                            <Typography {...styles.mvalueHeader}>{translate("Items")}</Typography>
                                                        </StyledWrapper>
                                                        <StyledWrapper
                                                            {...styles.TotalHeader}>
                                                            <Typography {...styles.mvalueHeader}>{translate("Total")}</Typography>
                                                        </StyledWrapper>
                                                        <StyledWrapper {...styles.ItemsTopHeader} />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.divider} />
                                                    <StyledWrapper>

                                                        {rowsSlice?.map(({
                                                            id,
                                                            creationDate,
                                                            erpOrderNumber,
                                                            webOrderNumber,
                                                            customerPO,
                                                            status,
                                                            orderTotalDisplay,
                                                            noOfOrderLine,
                                                            productLineItems,
                                                            orderDate,
                                                        }) => (
                                                            <>
                                                                <StyledWrapper
                                                                    key={id}
                                                                    {...styles.dataTableRow}
                                                                    data-test-selector={`myOrders_orderLine_${id}`}>
                                                                    <StyledWrapper {...styles.DateHeader}>
                                                                        <Typography>{creationDate}</Typography>
                                                                    </StyledWrapper>
                                                                    <StyledWrapper {...styles.NumberHeader}>
                                                                        {showAttributesForAvailableOrders(noOfOrderLine) ? (
                                                                            <OrderDetailPageTypeLink
                                                                                {...styles.Link}
                                                                                title={webOrderNumber || erpOrderNumber}
                                                                                orderNumber={webOrderNumber || erpOrderNumber}
                                                                                orderDate={orderDate}
                                                                                customerSuffix={customerSuffix}
                                                                            />
                                                                        ) : (
                                                                            <Typography {...styles.disabledLink}>
                                                                                {webOrderNumber || erpOrderNumber}
                                                                            </Typography>
                                                                        )}
                                                                    </StyledWrapper>
                                                                    <StyledWrapper {...styles.orderPOSubheader}>
                                                                        <Typography>{customerPO}</Typography>
                                                                    </StyledWrapper>
                                                                    <StyledWrapper {...styles.ReferenceHeader}>
                                                                        <Typography>{erpOrderNumber}</Typography>
                                                                    </StyledWrapper>
                                                                    <StyledWrapper {...styles.OrderStatus}><Typography>{status}</Typography></StyledWrapper>
                                                                    <StyledWrapper {...styles.totalItemsNumber}><Typography>{noOfOrderLine}</Typography></StyledWrapper>
                                                                    <StyledWrapper {...styles.TotalHeaderValue}>
                                                                        <Typography>{orderTotalDisplay}</Typography>
                                                                    </StyledWrapper>
                                                                    <StyledWrapper {...styles.ItemsHeader}>
                                                                        <StyledWrapper {...styles.MoreDetailWrap}>
                                                                            <StyledWrapper {...styles.MoreDetailProductLineItems}>

                                                                                {productLineItems?.map(
                                                                                    ({

                                                                                        shortDecription,
                                                                                        smallImagePath,
                                                                                        isAdonis,
                                                                                    }, index) => (
                                                                                        <>
                                                                                            {index < 3 ?
                                                                                                <StyledWrapper
                                                                                                    {...styles.MoreDetailProductLineItemImg}
                                                                                                >
                                                                                                    <LazyImage
                                                                                                        src={smallImagePath}
                                                                                                        altText={shortDecription}
                                                                                                    />
                                                                                                </StyledWrapper> :
                                                                                                <StyledWrapper
                                                                                                    {...styles.moreImagesWrapper}
                                                                                                    onClick={() =>
                                                                                                        handleButtonClick(webOrderNumber, orderDate, erpOrderNumber)
                                                                                                    }>
                                                                                                    <Typography>{(productLineItems.length - 3)}</Typography>
                                                                                                    <Typography>{translate("More")}</Typography>
                                                                                                </StyledWrapper>
                                                                                            }

                                                                                        </>
                                                                                    ),
                                                                                )}
                                                                            </StyledWrapper>
                                                                            {showAttributesForAvailableOrders(noOfOrderLine) ? (
                                                                                <StyledWrapper {...styles.viewDetailsLinkWrapper}
                                                                                    onClick={() =>
                                                                                        handleButtonClick(webOrderNumber, orderDate, erpOrderNumber)
                                                                                    }>
                                                                                    <Typography  {...styles.viewDetailsLink}>

                                                                                        {translate("Details")}

                                                                                    </Typography>
                                                                                    <ChevronRight />
                                                                                </StyledWrapper>
                                                                            ) : null}
                                                                        </StyledWrapper>
                                                                    </StyledWrapper>
                                                                </StyledWrapper>
                                                                <StyledWrapper {...styles.divider} />

                                                            </>
                                                        ),)}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                                <StyledWrapper
                                                    {...styles.seeAllDetailsWapper}
                                                >
                                                    <Typography {...styles.seeAllDetailsText}
                                                        onClick={() => { redirectToOrder() }}>{translate("See All Orders")}</Typography>
                                                </StyledWrapper>
                                            </>
                                        </Hidden>

                                        <Hidden below="sm" above="lg">
                                            <>
                                                <GridContainer {...styles.tabHeaderGridContainer}>
                                                    <GridItem width={2} {...styles.tabdateAndViewGridItem}>
                                                        <Typography {...styles.mvalueHeader}> {translate("Date")}</Typography>
                                                    </GridItem>
                                                    <GridItem width={2} {...styles.tabNumberGridItem}>

                                                        <Typography {...styles.mvalueHeader}>
                                                            {translate("Order #")}
                                                        </Typography>
                                                    </GridItem>
                                                    <GridItem width={3} {...styles.tabPOGridItem}>
                                                        <Typography {...styles.mvalueHeader}>{translate("PO #")}</Typography>
                                                    </GridItem>

                                                    <GridItem width={3} {...styles.tabPOGridItem}>
                                                        <Typography {...styles.mvalueHeader}>{translate("Ref #")}</Typography>
                                                    </GridItem>

                                                    <GridItem width={3} {...styles.tabOrderStatusGridItem}>
                                                        <Typography {...styles.mvalueHeader}>{translate("Status")}</Typography>
                                                    </GridItem>

                                                    <GridItem width={3} {...styles.tabOrderStatusGridItem}>
                                                        <Typography {...styles.mvalueHeader}>{translate("Items")}</Typography>
                                                    </GridItem>

                                                    <GridItem width={2} {...styles.tabTotalGridItem}>
                                                        <Typography {...styles.mvalueHeader}>{translate("Total")}</Typography>
                                                    </GridItem>

                                                </GridContainer>


                                                {rowsSlice.map(({
                                                    creationDate,
                                                    erpOrderNumber,
                                                    webOrderNumber,
                                                    customerPO,
                                                    status,
                                                    orderTotalDisplay,
                                                    noOfOrderLine,
                                                    productLineItems,
                                                    orderDate,
                                                }) => (
                                                    <GridContainer {...styles.tabGridContainer} className="tabletGridContainer">
                                                        <GridItem width={2} {...styles.tabdateAndViewGridItem}>
                                                            <Typography {...styles.tabCreationDateText}>{creationDate}</Typography>
                                                        </GridItem>
                                                        <GridItem width={2} {...styles.tabNumberGridItem}>
                                                            {showAttributesForAvailableOrders(noOfOrderLine) ? (
                                                                <OrderDetailPageTypeLink
                                                                    {...styles.Link}
                                                                    title={webOrderNumber || erpOrderNumber}
                                                                    orderNumber={webOrderNumber || erpOrderNumber}
                                                                    orderDate={orderDate}
                                                                    customerSuffix={customerSuffix}
                                                                />
                                                            ) : (
                                                                <Typography {...styles.disabledLink}>
                                                                    {webOrderNumber || erpOrderNumber}
                                                                </Typography>
                                                            )}
                                                        </GridItem>
                                                        <GridItem width={3} {...styles.tabPOGridItem}>
                                                            <Typography {...styles.mvalueTabPO}>{customerPO}</Typography>
                                                        </GridItem>

                                                        <GridItem width={3} {...styles.tabPOGridItem}>
                                                            <Typography {...styles.mvalue}>{erpOrderNumber}</Typography>
                                                        </GridItem>

                                                        <GridItem width={3} {...styles.tabOrderStatusGridItem}>
                                                            <Typography {...styles.mvalue}>{status}</Typography>
                                                        </GridItem>

                                                        <GridItem width={3} {...styles.tabOrderItemGridItem}>
                                                            <Typography {...styles.mvalue} style={{ textAlign: "center" }}>{noOfOrderLine}</Typography>
                                                        </GridItem>

                                                        <GridItem width={2} {...styles.tabTotalGridItem}>
                                                            <Typography {...styles.tabTotal}>{orderTotalDisplay}</Typography>
                                                        </GridItem>

                                                        <GridItem width={12} {...styles.tabitemsCommanGrid}>
                                                            <GridContainer {...styles.tabitemsDataContainer} >
                                                                <GridItem width={10}>

                                                                    {productLineItems?.map(
                                                                        ({ shortDecription, smallImagePath }, index) => (
                                                                            <>
                                                                                {index < 8 ?
                                                                                    <StyledWrapper
                                                                                        {...styles.MoreDetailProductLineItemImg}
                                                                                    >
                                                                                        <LazyImage
                                                                                            src={smallImagePath}
                                                                                            altText={shortDecription}
                                                                                        />
                                                                                    </StyledWrapper> :
                                                                                    <StyledWrapper
                                                                                        {...styles.moreImagesWrapper}
                                                                                        onClick={() =>
                                                                                            handleButtonClick(webOrderNumber, orderDate, erpOrderNumber)
                                                                                        }>
                                                                                        <Typography>{(productLineItems.length - 8)}</Typography>
                                                                                        <Typography>{translate("More")}</Typography>
                                                                                    </StyledWrapper>
                                                                                }

                                                                            </>
                                                                        ),
                                                                    )}
                                                                </GridItem>
                                                                <GridItem width={2}>
                                                                    {showAttributesForAvailableOrders(noOfOrderLine) ? (
                                                                        <StyledWrapper {...styles.viewDetailsLinkWrapperTab}
                                                                            onClick={() =>
                                                                                handleButtonClick(webOrderNumber, orderDate, erpOrderNumber)
                                                                            }>
                                                                            <Typography  {...styles.viewDetailsLink}>

                                                                                {translate("Details")}

                                                                            </Typography>
                                                                            <ChevronRight />
                                                                        </StyledWrapper>
                                                                    ) : null}
                                                                </GridItem>
                                                            </GridContainer>

                                                        </GridItem>
                                                    </GridContainer>
                                                ),
                                                )}
                                                <StyledWrapper
                                                    {...styles.seeAllDetailsWapper}
                                                >
                                                    <Typography {...styles.seeAllDetailsText}
                                                        onClick={() => { redirectToOrder() }}>{translate("See All Orders")}</Typography>
                                                </StyledWrapper>
                                            </>
                                        </Hidden>

                                        <Hidden above="sm">
                                            <>
                                                {rowsSlice.map(
                                                    ({
                                                        creationDate,
                                                        erpOrderNumber,
                                                        webOrderNumber,
                                                        customerPO,
                                                        status,
                                                        orderTotalDisplay,
                                                        noOfOrderLine,
                                                        productLineItems,
                                                        orderDate,
                                                    }) => (
                                                        <>
                                                            <GridContainer {...styles.mobileGridContainer}>
                                                                <GridContainer>
                                                                    <GridItem width={6} {...styles.dateAndViewGridItem}>
                                                                        <Typography {...styles.creationDateText}>{creationDate}</Typography>
                                                                    </GridItem>
                                                                    <GridItem width={6} {...styles.dateAndViewGridItem}>
                                                                        {showAttributesForAvailableOrders(noOfOrderLine) ? (
                                                                            <StyledWrapper {...styles.viewDetailsLinkWrapperTab}
                                                                                onClick={() =>
                                                                                    handleButtonClick(webOrderNumber, orderDate, erpOrderNumber)
                                                                                }>
                                                                                <Typography  {...styles.viewDetailsLink}>

                                                                                    {translate("View Details")}

                                                                                </Typography>
                                                                                <ChevronRight />
                                                                            </StyledWrapper>
                                                                        ) : null}
                                                                    </GridItem>
                                                                </GridContainer >
                                                                <StyledWrapper {...styles.dividerMobile} />
                                                                <GridItem width={12} {...styles.commanGridItem}>
                                                                    <StyledWrapper>
                                                                        <Typography {...styles.mheading}>Order #: </Typography>
                                                                        <Typography {...styles.mvaluemobile} onClick={() =>
                                                                                            handleButtonClick(webOrderNumber, orderDate, erpOrderNumber)
                                                                                        }>
                                                                        
                                                                            <Typography {...styles.Link}>
                                                                                {webOrderNumber || erpOrderNumber}
                                                                            </Typography>
                                                                       
                                                                        </Typography>
                                                                    </StyledWrapper>
                                                                    <StyledWrapper>
                                                                        <Typography {...styles.mheading}>Total #: </Typography>
                                                                        <Typography {...styles.mvalue}>{orderTotalDisplay}</Typography>
                                                                    </StyledWrapper>
                                                                </GridItem>
                                                                {customerPO !== "" &&
                                                                    <GridItem width={12} {...styles.commanGridItem}>
                                                                        <StyledWrapper>
                                                                            <Typography {...styles.mheading}>PO #: </Typography>
                                                                            <Typography {...styles.mvalue}>{customerPO}</Typography>
                                                                        </StyledWrapper>
                                                                    </GridItem>
                                                                }
                                                                {erpOrderNumber !== "" &&
                                                                    <GridItem width={12} {...styles.commanGridItem}>
                                                                        <StyledWrapper>
                                                                            <Typography {...styles.mheading}>Ref #: </Typography>
                                                                            <Typography {...styles.mvalue}>{erpOrderNumber}</Typography>
                                                                        </StyledWrapper>
                                                                    </GridItem>
                                                                }
                                                                <StyledWrapper {...styles.divider} />
                                                                <StyledWrapper {...styles.commanGridItem} style={{ paddingTop: "8px" }}>

                                                                    <Typography {...styles.mvalue}>{status}</Typography>
                                                                    <StyledWrapper {...styles.verticalDivider} />
                                                                        <Typography {...styles.mvalue}>{noOfOrderLine} Items</Typography>
                                                                </StyledWrapper>
                                                                <GridItem width={12}>

                                                                    {productLineItems?.map(
                                                                        ({ shortDecription, smallImagePath }, index) => (
                                                                            <>
                                                                                {index < 3 ?
                                                                                    <StyledWrapper
                                                                                        {...styles.MoreDetailProductLineItemImg}
                                                                                    >
                                                                                        <LazyImage
                                                                                            src={smallImagePath}
                                                                                            altText={shortDecription}
                                                                                        />
                                                                                    </StyledWrapper> :
                                                                                    <StyledWrapper
                                                                                        {...styles.moreImagesWrapper}
                                                                                        onClick={() =>
                                                                                            handleButtonClick(webOrderNumber, orderDate, erpOrderNumber)
                                                                                        }>
                                                                                        <Typography>{(productLineItems.length - 3)}</Typography>
                                                                                        <Typography>{translate("More")}</Typography>
                                                                                    </StyledWrapper>
                                                                                }

                                                                            </>
                                                                        ),
                                                                    )}
                                                                </GridItem>
                                                            </GridContainer>
                                                            <StyledWrapper {...styles.cardDividerMobile} />
                                                        </>
                                                    ),
                                                )}

                                                <StyledWrapper
                                                    {...styles.seeAllDetailsWapperMobile}
                                                >
                                                    <Typography {...styles.seeAllDetailsText}
                                                        onClick={() => { redirectToOrder() }}>{translate("See All Orders")}</Typography>
                                                </StyledWrapper>
                                            </>
                                        </Hidden>

                                    </StyledWrapper>
                                </>
                            }
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>

            </StyledWrapper >
        }</>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ADIHomeMyRecentOrder)),
    definition: {
        group: "Basic",
        icon: "Orders",
        displayName: "ADI Home Page Recent Orders",
        fieldDefinitions: [
        ],
    },
};

export default widgetModule;
